import { Navigate, Route, Routes } from 'react-router-dom'
import { useAuth } from './auth/AuthContext'
import { AppShell } from './components/AppShell'
import { CalendarPage } from './pages/CalendarPage'
import { DashboardPage } from './pages/DashboardPage'
import { EntityDetailPage } from './pages/EntityDetailPage'
import { EntityListPage } from './pages/EntityListPage'
import { NotFoundPage } from './pages/NotFoundPage'
import { LoginPage } from './pages/LoginPage'
import { OpeningDetailPage } from './pages/OpeningDetailPage'

const entities = ['leads', 'customers', 'contacts', 'opportunities', 'quotes', 'projects', 'suppliers', 'tasks', 'issues', 'products'] as const
const detailEntities = ['leads', 'customers', 'contacts', 'opportunities', 'quotes', 'projects', 'suppliers', 'issues'] as const

export default function App() {
  const { status } = useAuth()

  if (status === 'checking') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-pine-950">
        <div className="text-center">
          <img src="/termovista-icon.png" alt="TermoVista" className="mx-auto h-14 w-14 animate-pulse rounded-2xl" />
          <p className="mt-4 text-sm font-medium text-pine-200">Checking your session…</p>
        </div>
      </div>
    )
  }

  if (status === 'unauthenticated') return <LoginPage />

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<DashboardPage />} />
        <Route path="calendar" element={<CalendarPage />} />
        {entities.map((entity) => <Route key={entity} path={entity} element={<EntityListPage entity={entity} />} />)}
        {detailEntities.map((entity) => <Route key={`${entity}-detail`} path={`${entity}/:id`} element={<EntityDetailPage entity={entity} />} />)}
        <Route path="openings/:id" element={<OpeningDetailPage />} />
        <Route path="dashboard" element={<Navigate to="/" replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
